import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Grid,
  IconButton,
  TextField,
  ButtonGroup,
  FormControl,
  MenuItem,
  Select,
} from '@material-ui/core';
import styled, { css } from 'styled-components';
import { color } from 'styles/utils';
import cx from 'classnames';
import useInput from 'lib/hooks/useInput';
import { useDidUpdateEffect } from 'lib/utils';
import MuiWrapper from 'components/common/input/MuiWrapper';
import MuiButton from 'components/common/button/MuiButton';
import T from 'components/common/text/T';
import { person_bubble_circle, partner_image_circle } from 'components/base/images';
import { StyledPlainButtonOuter } from 'components/common/styled/Button';
import CustomSpan from 'components/common/text/CustomSpan';
import ImgCrop from 'components/common/images/ImgCrop';
import { useShallowAppSelector } from 'store/hooks';
import CloseIcon from '@material-ui/icons/Close';
import Color from 'color';
import { partnerTypeList } from 'lib/mapper';
import indicationInfo from 'static/files/unit/indicationInfo.json';
import ReplyIcon from '@material-ui/icons/Reply';
import Tooltip from '@material-ui/core/Tooltip';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';

interface PartnerModalRequestProps {
  minorData: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  majorData: {
    value: string | null;
    onChange: (e: any) => void;
    setValue: (value: string) => void;
  };
  selectedPartnerData: object | any;
  isSearchValue: {
    value: boolean | any;
    onChange: (e: any) => void;
    setValue: (value: boolean) => void;
  };

  onClickGoToBack: () => void;
  onSubmitAnswerReceivedRequest: (data: any) => void;
  onSubmitRegisterNewPartner: (data: any) => void;
}

/**
 * @param {PartnerModalRequestProps} { selectedPartner }
 * @return {*}
 */
function PartnerModalRequest({
  majorData,
  minorData,
  selectedPartnerData,
  isSearchValue,
  onClickGoToBack,
  onSubmitAnswerReceivedRequest,
  onSubmitRegisterNewPartner,
}: PartnerModalRequestProps) {
  const userTypeIdx = useInput('');

  const receivedRequestAnswerState: { id: number; value: string }[] = [
    { id: 1, value: 'accept' },
    { id: 2, value: 'reject' },
  ];

  useEffect(() => {
    console.log('HDS] selectedPartnerData ______ ', selectedPartnerData);
  }, [selectedPartnerData]);

  const handleRegisterNewPartnerData = (data: object) => {
    const reqData = {
      ...data,
      userTypeIdx: userTypeIdx.value,
    };
    onSubmitRegisterNewPartner(reqData);
  };

  const handleAnswerReceivedRequest = (data: object, state: string) => {
    const reqData = {
      ...data,
      userTypeIdx: userTypeIdx.value,
      state: receivedRequestAnswerState.find(i => i.value === state)?.id,
    };
    onSubmitAnswerReceivedRequest(reqData);
  };

  return (
    <StyledPartnerModalRequest data-component-name="PartnerModalRequest">
      <div className="partnerModalRequest__container">
        <div className="partnerModalRequest__info_wrapper">
          <div
            className={cx('partnerModalRequest__redo_button_box', {
              isSearchbar: !!isSearchValue.value ? true : false,
            })}
          >
            <div className="partnerModalRequest__redo_button" onClick={onClickGoToBack}>
              <NavigateBeforeIcon />
            </div>
            <span className="partnerModalRequest__redo_button_text">
              <T>GLOBAL_PREV</T>
            </span>
          </div>
          <div className="partnerModalRequest__info_box">
            <Grid container className="partnerModalRequest__info">
              <Grid item className="partnerModalRequest__info_image ">
                <div className="partnerModalRequest__info_image_box">
                  {!!selectedPartnerData.profileImg ? (
                    <ImgCrop width={60} isCircle src={selectedPartnerData.profileImg} />
                  ) : (
                    <img src={partner_image_circle} />
                  )}
                </div>
              </Grid>
              <Grid item className="partnerModalRequest__info_content">
                {!!selectedPartnerData && (
                  <>
                    <div className="partnerModalRequest__info_row name">
                      <Tooltip
                        className="partnerModalRequest__info_tooltip"
                        title={selectedPartnerData?.name}
                        placement="top"
                        // open={true}
                        disableHoverListener={false}
                        disableFocusListener={true}
                        disableTouchListener={true}
                      >
                        <span>{selectedPartnerData?.name}</span>
                      </Tooltip>
                    </div>
                    <div className="partnerModalRequest__info_row userType">
                      <span className="partnerModalRequest__info_row_lable">
                        <T>GLOBAL_TYPE</T>
                      </span>
                      <span className="partnerModalRequest__info_row_contents">
                        <T>
                          {
                            partnerTypeList.find(i => i.id === selectedPartnerData.userTypeIdx)
                              ?.text
                          }
                        </T>
                      </span>
                    </div>
                    <div className="partnerModalRequest__info_row email">
                      <span className="partnerModalRequest__info_row_lable">
                        <T>GLOBAL_SYNC_ID</T>
                      </span>
                      <Tooltip
                        className="partnerModalRequest__info_tooltip"
                        title={selectedPartnerData?.email}
                        placement="top"
                        // open={true}
                        disableHoverListener={false}
                        disableFocusListener={true}
                        disableTouchListener={true}
                      >
                        <span className="partnerModalRequest__info_row_contents">
                          {selectedPartnerData?.email}
                        </span>
                      </Tooltip>
                    </div>
                    <div className="partnerModalRequest__info_row phone">
                      <span className="partnerModalRequest__info_row_lable">
                        <T>GLOBAL_MOBILE</T>
                      </span>
                      <span className="partnerModalRequest__info_row_contents">
                        {selectedPartnerData?.phone}
                      </span>
                    </div>
                    <div className="partnerModalRequest__info_row region">
                      <span className="partnerModalRequest__info_row_lable">
                        <T>GLOBAL_COUNTRY</T>
                      </span>
                      <span className="partnerModalRequest__info_row_contents">
                        {selectedPartnerData?.countryName}
                      </span>
                    </div>
                  </>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
        {minorData.value === 'received' && (
          <StyledPlainButtonOuter
            className="partnerModalRequest__button_box receivedRequest"
            backgroundColor={color.navy_blue}
            left="50%"
            width={410}
            height={76}
          >
            <div className="receivedRequest__btn_box">
              <MuiButton
                config={{
                  width: '95px',
                  color: color.gray_week,
                }}
                disableElevation
                variant="contained"
                className="xl border-radius-round inset-shadow-default receivedRequest__reject_btn"
                onClick={() => {
                  handleAnswerReceivedRequest(selectedPartnerData, 'reject');
                }}
              >
                <T>PROJECT_REJECT</T>
              </MuiButton>
              <MuiButton
                config={{
                  width: '295px',
                }}
                disableElevation
                variant="contained"
                className="xl border-radius-round inset-shadow-default receivedRequest__accept_btn"
                onClick={() => {
                  handleAnswerReceivedRequest(selectedPartnerData, 'accept');
                }}
              >
                <span className="btn-shadow-inset"></span>
                <T>GLOBAL_ACCEPT</T>
              </MuiButton>
            </div>
          </StyledPlainButtonOuter>
        )}
        {minorData.value === 'waiting' && (
          <StyledPlainButtonOuter
            className="partnerModalRequest__button_box requestWaiting"
            backgroundColor={color.navy_blue}
            left="50%"
            width={410}
            height={76}
          >
            <MuiButton
              type="submit"
              config={{
                width: '320px',
              }}
              disabled={true}
              disableElevation
              color="primary"
              variant="contained"
              disablebackground={color.navy_blue}
              disablefontcolor="#ffffff"
              className="xl border-radius-round partner_ok_button requestWaiting__btn"
              endIcon={
                <div
                  aria-label="cancel modal"
                  className="partner_cancel_button"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  <CloseIcon htmlColor="white" fontSize="inherit" />
                </div>
              }
            >
              <T>GLOBAL_WAITING</T>
            </MuiButton>
          </StyledPlainButtonOuter>
        )}
        {minorData.value === 'new' && (
          <StyledPlainButtonOuter
            className="partnerModalRequest__button_box requestRegister"
            backgroundColor={color.navy_blue}
            left="50%"
            width={410}
            height={76}
          >
            <MuiButton
              type="submit"
              config={{
                width: '320px',
              }}
              disableElevation
              color="primary"
              variant="contained"
              disablebackground={color.navy_blue}
              disablefontcolor="#ffffff"
              className="xl border-radius-round partner_ok_button requestRegister__btn"
              endIcon={
                <div
                  aria-label="cancel modal"
                  className="partner_cancel_button"
                  onClick={e => {
                    e.preventDefault();
                  }}
                >
                  <CloseIcon htmlColor="white" fontSize="inherit" />
                </div>
              }
              onClick={() => {
                handleRegisterNewPartnerData(selectedPartnerData);
              }}
            >
              <T>GLOBAL_OK</T>
            </MuiButton>
          </StyledPlainButtonOuter>
        )}
      </div>
    </StyledPartnerModalRequest>
  );
}

const StyledPartnerModalRequest = styled.section<{}>`
  .partnerModalRequest__container {
    height: 390px;
    width: 100%;
    margin-bottom: 30px;
    position: relative;
    background-color: #ffffff;
    .partnerModalRequest__info_wrapper {
      .partnerModalRequest__redo_button_box {
        display: none;
        margin-bottom: 10px;
        &.isSearchbar {
          display: flex;
          align-items: center;
        }
        .partnerModalRequest__redo_button {
          width: 26px;
          height: 26px;
          border: 1px solid #25256f;
          background-color: #ffffff;
          color: #25256f;
          border-radius: 50%;
          align-items: center;
          justify-content: center;
          display: flex;
          &:hover {
            cursor: pointer;
          }
        }
        .partnerModalRequest__redo_button_text {
          font-size: 14px;
          color: #303030;
          font-weight: 500;
          /* display: flex;
          align-items: center; */
          padding-left: 8px;
          height: 20px;
          line-height: 20px;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .partnerModalRequest__info_box {
        /* height: 230px; */
        height: 256px;
        width: 100%;
        align-items: center;
        background-color: #ffffff;
        border-radius: 5px;
        /* margin-bottom: 20px; */
        position: relative;
        border: 1px solid #e1e1e1;

        .partnerModalRequest__info {
          height: 100%;
          padding: 30px;
          p {
            color: #ffffff;
            &:first-child {
              margin-bottom: 28px;
            }
            &:last-child {
              margin-top: 7px;
            }
          }
          .partnerModalRequest__info_image {
            width: 60px;
            .partnerModalRequest__info_image_box {
              width: 60px;
              height: 60px;
              border-radius: 30px;
              background-color: #ffffff;
              border: solid 1px #ebebeb;
            }
          }
          .partnerModalRequest__info_content {
            /* width: 350px; */
            width: calc(100% - 60px);
            padding-left: 30px;
            .partnerModalRequest__info_row {
              /* width: 310px; */
              width: 100%;
              height: 26px;
              color: #303030;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              display: flex;
              font-size: 14px;
              .partnerModalRequest__info_tooltip {
                /* width: 310px; */
                /* width: 100%; */
              }
              &.name {
                margin-top: 19px;
                font-size: 20px;
                font-weight: 500;
              }
              &.userType {
                margin-top: 17px;
              }
              &.email,
              &.phone,
              &.region {
                margin-top: 8px;
                /* font-size: 14px;
                font-weight: 500; */
              }

              .partnerModalRequest__info_row_lable {
                width: 84px;
                display: flex;
                align-items: center;
              }
              .partnerModalRequest__info_row_contents {
                display: flex;
                align-items: center;
              }
            }
          }
        }
      }
      .partnerModalRequest__select_box {
        align-items: center;
        height: 40px;
        .partnerModalRequest__select_label {
          width: 140px;
        }
        .partnerModalRequest__select_item_wrapper {
          width: 350px;
        }
      }
    }

    .partnerModalRequest__button_box {
      .partner_ok_button {
        border: 1px solid #ffffff;
        position: relative;
        .partner_cancel_button {
          position: absolute;
          top: 50%;
          right: 10px;
          border: 1px solid #ffffff;
          border-radius: 18px;
          width: 36px;
          height: 36px;
          transform: translate(0, -50%);
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
      }

      .receivedRequest__btn_box {
        position: relative;
        display: flex;
        .receivedRequest__reject_btn {
          position: relative;
          z-index: 2;
        }
        .receivedRequest__accept_btn {
          margin-left: -10px;
          background: rgb(0, 166, 226);
          background: linear-gradient(90deg, rgba(0, 166, 226, 1) 0%, rgba(8, 123, 238, 1) 100%);
          border: none;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
          overflow: hidden;
          &:hover {
            background: ${`linear-gradient(
            90deg,
            ${Color('rgba(0, 166, 226, 1)').darken(0.12)} 0%,
            ${Color('rgba(8, 123, 238, 1)').darken(0.12)} 100%
          )`};
          }
          .btn-shadow-inset {
            position: absolute;
            top: -5px;
            left: -46px;
            width: 66px;
            height: 66px;
            border-radius: 33px;
            background-color: ${color.navy_blue};
            box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.16);
          }
        }
      }
    }
  }
`;

export default React.memo(PartnerModalRequest);
